module.exports = __webpack_public_path__ + "assets/img/solar-panels-cloudy.8acfc7ce.jpg";